import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OverAskConfig } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';

import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';
import { BetslipOverAskPendingBaseComponent } from '../../betslip-over-ask-pending-base.component';

@Component({
    selector: 'bs-betslip-over-ask-pending',
    templateUrl: './betslip-over-ask-pending.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask-pending.component.scss'],
    standalone: false,
})
export class BetslipOverAskPendingComponent extends BetslipOverAskPendingBaseComponent {
    constructor(store: Store, overAskConfig: OverAskConfig, overAskMessagesProvider: OverAskMessagesProvider) {
        super(store, overAskConfig, overAskMessagesProvider);

        this.messages = {
            reviewTitle: overAskMessagesProvider.messages.pendingTitle,
            reviewInformation: overAskMessagesProvider.messages.reviewInfoMessage,
            progressBarInfoText: overAskMessagesProvider.messages.pendingCheckingYourBet,
            cancelButtonTitle: overAskMessagesProvider.messages.cancel,
        };
    }
}
